{
  "@context": "https://hubmapconsortium.github.io/ccf-ontology/ccf-context.jsonld",
  "@type": "http://purl.org/ccf/SpatialEntity"
}
